const resolveNumber = ({ rawVal }: any) => +rawVal;
export default resolveNumber;
